var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DataRender',{staticClass:"EnterpriseMain",attrs:{"onLoad":_vm.handleLoad}},[_c('div',{staticClass:"EnterpriseMain-head"},[_c('div',{staticClass:"title"},[_vm._v("当前："+_vm._s(_vm.info.company_name))])]),_c('router-view',{key:_vm.fullPath})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }